export const GUIDE_DISABLE_STORAGE_KEY = 'getdemo_guideDisable';

let guideDisableNoticeEmitted = false;

const emitGuideDisableNoticeOnce = (): void => {
  if (guideDisableNoticeEmitted || typeof window === 'undefined') return;
  guideDisableNoticeEmitted = true;
  console.info(
    `[Getdemo] Tour guide is disabled (guideDisable query or localStorage key ${GUIDE_DISABLE_STORAGE_KEY}).`
  );
};

export const resetGuideDisableNoticeForTests = (): void => {
  guideDisableNoticeEmitted = false;
};

export const isGuideDisabled = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    const params = new URLSearchParams(window.location.search);
    const param = params.get('guideDisable');
    if (param === 'true') {
      localStorage.setItem(GUIDE_DISABLE_STORAGE_KEY, 'true');
      emitGuideDisableNoticeOnce();
      return true;
    }
    if (param === 'false') {
      localStorage.removeItem(GUIDE_DISABLE_STORAGE_KEY);
      return false;
    }
    const fromStorage = localStorage.getItem(GUIDE_DISABLE_STORAGE_KEY) === 'true';
    if (fromStorage) {
      emitGuideDisableNoticeOnce();
    }
    return fromStorage;
  } catch {
    return false;
  }
};
